module.exports = __webpack_public_path__ + "img/4_06.39e690be.png";